
import {defineComponent} from "vue";

const __default__ = defineComponent({
  name: "SectionDivisor",
  props: {
    title: {
      type: String,
    },
    colorLabel: {
      type: String,
    },
    colorBackground: {
      type: String,
    },
    colorLine: {
      type: String,
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0dfd641c": (_ctx.colorBackground),
  "7b8c5346": (_ctx.colorLabel),
  "56910962": (_ctx.colorLine)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__